import { Map } from "schemas/functions";
import { routes } from "schemas/routes";

export enum AutopilotOnboardingStep {
  welcome = "welcome",
  about = "about",
  templates = "templates",
  importContacts = "import-contacts",
  complete = "complete",
}

export const DefaultAutopilotOnboardingSteps = [
  AutopilotOnboardingStep.welcome,
  AutopilotOnboardingStep.about,
  AutopilotOnboardingStep.templates,
  AutopilotOnboardingStep.importContacts,
  AutopilotOnboardingStep.complete,
];

export const StepToRoute: Record<AutopilotOnboardingStep, string> = {
  [AutopilotOnboardingStep.welcome]: routes.onboardingAutopilotWelcome,
  [AutopilotOnboardingStep.about]: routes.onboardingAutopilotAbout,
  [AutopilotOnboardingStep.templates]: routes.onboardingAutopilotTemplates,
  [AutopilotOnboardingStep.importContacts]:
    routes.onboardingAutopilotImportContacts,
  [AutopilotOnboardingStep.complete]: routes.onboardingAutopilotComplete,
};

export const DefaultAutopilotOnboardingStepInfo: Map = {
  [AutopilotOnboardingStep.about]: {
    name: "About",
    time: "2-3",
  },
  [AutopilotOnboardingStep.templates]: {
    name: "Templates",
    time: "1-2",
  },
  [AutopilotOnboardingStep.importContacts]: {
    name: "Import Contacts",
    time: "1-2",
  },
};
